import { avatarColor, initials } from '@/lib/domain/format';

interface AvatarProps {
  name: string;
  /** Chave estável para a cor (id quando houver; senão o próprio nome). */
  colorKey?: string;
  size?: number;
}

/** Avatar circular com iniciais e cor determinística (o backend só nos dá nomes — DEC-030). */
export function Avatar({ name, colorKey, size = 24 }: AvatarProps) {
  const fz = size <= 20 ? 9 : size <= 28 ? 10 : 11;
  return (
    <div
      title={name}
      className="inline-flex shrink-0 items-center justify-center rounded-full font-mono font-semibold"
      style={{
        width: size,
        height: size,
        fontSize: fz,
        letterSpacing: 0.3,
        color: '#f4f1eb',
        background: avatarColor(colorKey ?? name),
        boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.08)',
      }}
    >
      {initials(name)}
    </div>
  );
}

interface AvatarStackProps {
  /** Nomes (ex.: líder seguido da equipe). A cor deriva do próprio nome. */
  names: string[];
  max?: number;
  size?: number;
}

/** Pilha de avatares sobrepostos; "+N" quando excede `max`. */
export function AvatarStack({ names, max = 3, size = 18 }: AvatarStackProps) {
  const shown = names.slice(0, max);
  const rest = names.length - shown.length;
  return (
    <div className="inline-flex items-center">
      {shown.map((n, i) => (
        <div
          key={`${n}-${i}`}
          className="relative rounded-full"
          style={{ marginLeft: i === 0 ? 0 : -6, zIndex: 10 - i, outline: '2px solid var(--vega-surface)' }}
        >
          <Avatar name={n} size={size} />
        </div>
      ))}
      {rest > 0 && (
        <div
          className="inline-flex items-center justify-center rounded-full font-mono font-semibold"
          style={{
            marginLeft: -6,
            width: size,
            height: size,
            fontSize: 10,
            background: 'var(--vega-line)',
            color: 'var(--vega-ink-2)',
            outline: '2px solid var(--vega-surface)',
          }}
        >
          +{rest}
        </div>
      )}
    </div>
  );
}
